import {h, Fragment} from "preact"
import { SerpElement } from "@nosto/preact"
import { useEffect, useMemo } from "preact/hooks"
import { variantFilterMatch } from "../config"

export default function Product({ product, activeFilters }) {
    const handle = useMemo(() => product.url.split("/products/")[1], []);

    const activeSku = useMemo(() => {
        if (product.skus?.length === 1 || !activeFilters || activeFilters?.length < 1) return product.skus[0];
        let match, value, fields;
        for(let i = 0; i < activeFilters.length; i++) {
            value = activeFilters[i].value.toLowerCase();
            fields = variantFilterMatch.find(filter => filter.filterField === activeFilters[i].field);
            match = product.skus.find(sku => {
                const skuValue = sku.customFields.find(f => f.key === fields.skuCustomFieldKey)?.value?.toLowerCase();
                return skuValue === value || skuValue.includes(value)
            })
            if(match) {
                break;
            }
        }
        return match;
    }, [ activeFilters, product.skus, variantFilterMatch ]);

    return (
        <SerpElement
            as="li"
            hit={product}
            ariaLabel={`Product ${product.name}`}
            class="ns-product w-full flex"
            product-card=""
        >
            <dynamic-product-card 
                template="product-card"
                class="w-full flex"
                handle={handle}
                variant-id={activeSku?.id}
            >
                <div class='product-card-skeleton' />
            </dynamic-product-card>
        </SerpElement>
    )
}